/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { stringify } from '@nab/utils';

/**
 * Internal dependencies
 */
import UnitWithRangeControl from '../unit-with-range-control';

type LineHeightControlProps = {
	readonly value: string | undefined;
	readonly onChange: ( value: string | undefined ) => void;
	readonly disabled?: boolean;
};

export function LineHeightControl( {
	value = '',
	onChange,
	disabled,
}: LineHeightControlProps ): JSX.Element {
	value =
		/^[\d.]+$/.test( value ) && '0' !== value
			? `${ Number.parseFloat( value ) * 100 }%`
			: value;
	return (
		<UnitWithRangeControl
			label={ _x( 'Line height', 'text', 'nelio-ab-testing' ) }
			value={ value }
			units={ [ 'px', 'em', 'rem', '%' ] }
			onChange={ ( lineHeight ) => onChange( stringify( lineHeight ) ) }
			__next40pxDefaultSize
			disabled={ disabled }
			max={ value.includes( '%' ) ? 200 : undefined }
		/>
	);
}
